import BotLogoMark from "@/components/chat/BotLogoMark";

/**
 * Bot / AI assistant avatar for inbox message rows.
 * Renders the single default bot logo (inline SVG) inside a circular frame.
 * @param {{ className?: string, size?: "sm" | "md" }} props
 */
export default function BotMessageAvatar({ className = "", size = "md" }) {
  const dim = size === "sm" ? "h-7 w-7" : "h-8 w-8";
  return (
    <span
      aria-hidden
      className={`${dim} shrink-0 overflow-hidden rounded-full ring-2 ring-violet-100 shadow-md dark:ring-violet-900/60 ${className}`.trim()}
    >
      <BotLogoMark />
    </span>
  );
}
